import { createFrontendModule, PageBlueprint } from "@backstage/frontend-plugin-api";
import HomeIcon from '@material-ui/icons/Home'

export const homeModule = createFrontendModule({
    pluginId: 'home',
    extensions: [
        PageBlueprint.make({
            name: "home",
            params: {
                path: '/',
                loader: () => import('./HomePage').then(m => <m.HomePage />),
                noHeader: true,
                title: 'Home',
                icon: <HomeIcon />,
            },
        }),
    ],
})
